import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { LOGIN_ROUTE } from '../constants';
import { useAuth } from '../auth-context';
import { redirectStorage } from '../storage';
import { AuthSplash } from './auth-splash';

/**
 * Route guard. While the initial session check is in flight we render a splash
 * rather than redirecting — bouncing to /login first would flash the login
 * screen for every authenticated reload. A logout leaving for the IdP is `pending` too.
 *
 * An anonymous visit leaves its address behind (`redirectStorage`, in `sessionStorage`), which
 * survives the round trip to the IdP in the same tab: `/auth/callback` lands there once the
 * session is open.
 */
export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'pending') {
    return <AuthSplash />;
  }

  if (status === 'anonymous') {
    redirectStorage.set(`${location.pathname}${location.search}`);
    return <Navigate to={LOGIN_ROUTE} replace />;
  }

  return <Outlet />;
}
